export { spotlightExtensionProvider } from './ui/spotlight-manifest';
export type {
	SpotlightContentProps,
	ImageProps,
	SpotlightParameters,
	SpotlightActions,
	SpotlightParameterPaths,
} from './types';
export { Spotlight } from './ui/spotlight-hub-element/spotlight-extension/spotlight';
export {
	SpotlightExtension,
	type SpotlightExtensionProps,
} from './ui/spotlight-hub-element/spotlight-extension';
export { SpotlightConfigPanelContent } from './ui/spotlight-hub-element/spotlight-config-panel';
export { spotlightHubElement } from './ui/spotlight-hub-element';
export { SPOTLIGHT_EXTENSION_KEY } from './constants';
export { mockInitialSpotlightParameters } from './utils/spotlightDataMocks';
export type { spotlightExtensionProviderWrapperProps } from './ui/spotlight-manifest';
